import { PackageProviderName } from 'data/ppoints/constants';
import useSWR from 'swr';
import swrConfig from 'utils/swrConfig';
import { GetShippingRateMappingsOptions, getShippingRateMappings } from '../api/shippingRateMappingApi';
import { ShippingRateMapping, ShippingRateMappings } from '../models/shipping-rate-mapping';

export interface UseShippingRateMappingsReturn {
    mappings: ShippingRateMapping[];
    data: ShippingRateMappings | undefined;
    isLoading: boolean;
    error: Error;
    mutate: () => void;
}

export const useShippingRateMappings = (
    provider: PackageProviderName,
    { include, exclude }: GetShippingRateMappingsOptions = {}
): UseShippingRateMappingsReturn => {
    // include/exclude are part of the cache key so switching filters doesn't read another filter's
    // cached response.
    const cacheKey = provider
        ? ['shipping-rate-mappings', provider, include?.join(',') ?? '', exclude?.join(',') ?? ''].join('-')
        : null;

    const { data, isLoading, error, mutate } = useSWR<ShippingRateMappings>(
        cacheKey,
        () => getShippingRateMappings(provider, { include, exclude }),
        swrConfig
    );

    return {
        mappings: data?.mappings ?? [],
        data,
        isLoading,
        error,
        mutate,
    };
};
